<template>
  <div class="antdiy">
    <TopHP title="ANTDIY: Most Powerful AliExpress Dropshipping Tool" :content="frontList" btn="Get Started"
      img="/static/imgs/antdiy_top.svg" bg='top_bg_p_diy' tlcontent='top_left_content_diy'
      tlsymbol='top_left_symbol_diy'></TopHP>
    <div class="antdiy_content">
      <div class="antdiy_content_box">
        <div class="antdiy_content_line antdiy_content_line2">
          <div class="antdiy_content_line_img1 antdiy_content_line_img">
            <img class="img_bottom img_bottom1" src="/static/imgs/antdiy_1_bottom.png">
            <ImgScale class="img_top_1" url="/static/imgs/antdiy_1_top.png" type="circle" v-if="!isMobileDiy">
            </ImgScale>
            <img class="img_top_1" src="/static/imgs/antdiy_1_top.png" v-else>
          </div>
          <div class="antdiy_content_line_text">
            <div class="title_icon antdiy_content_line_text_symbol"></div>
            <div class="antdiy_content_line_text_title">Import Products with 1-click</div>
            <div class="antdiy_content_line_text_subtitle">Quickly add trending products from AliExpress</div>
            <div class="antdiy_content_line_text_content">We have more than 100 million competitive prices products.
              Everything you can think of is here! You just need to add them to your Shopify store with 1-click, and
              ready to sell.</div>
          </div>
        </div>
        <div class="antdiy_content_line">
          <div class="antdiy_content_line_text">
            <div class="title_icon antdiy_content_line_text_symbol"></div>
            <div class="antdiy_content_line_text_title">Automated Supply Chain Integration</div>
            <div class="antdiy_content_line_text_subtitle">Easily manage all your orders in one place</div>
            <div class="antdiy_content_line_text_content">Our complete supply chain system can help you quickly and
              automatically sync orders, track order delivery, save time and human resources, ensure smooth business
              operation.</div>
          </div>
          <div class="antdiy_content_line_img2 antdiy_content_line_img">
            <img class="img_bottom img_bottom2" src="/static/imgs/antdiy_2_bottom.png">
            <ImgScale class="img_top_2" url="/static/imgs/antdiy_2_top.png" type="circle" v-if="!isMobileDiy">
            </ImgScale>
            <img class="img_top_2" src="/static/imgs/antdiy_2_top.png" v-else>
          </div>
        </div>
        <div class="antdiy_content_line antdiy_content_line2">
          <div class="antdiy_content_line_img3 antdiy_content_line_img">
            <img class="img_bottom img_bottom3" src="/static/imgs/antdiy_3_bottom.png">
            <ImgScale class="img_top_3" url="/static/imgs/antdiy_3_top.png" type="circle" v-if="!isMobileDiy">
            </ImgScale>
            <img class="img_top_3" src="/static/imgs/antdiy_3_top.png" v-else>
          </div>
          <div class="antdiy_content_line_text">
            <div class="title_icon antdiy_content_line_text_symbol"></div>
            <div class="antdiy_content_line_text_title">Convenient Search & Edit Product</div>
            <div class="antdiy_content_line_text_subtitle">Saves you tons of time finding and editing product</div>
            <div class="antdiy_content_line_text_content">Excellent search tools and convenient filters allow you easily
              find awesome products. Professional editing functions allow you to customize product details and win more
              potential users.</div>
          </div>
        </div>
        <div class="antdiy_content_line">
          <div class="antdiy_content_line_text">
            <div class="title_icon antdiy_content_line_text_symbol"></div>
            <div class="antdiy_content_line_text_title">Variant Mapping</div>
            <div class="antdiy_content_line_text_subtitle">Map your products to any AliExpress supplier</div>
            <div class="antdiy_content_line_text_list"><em></em>Find alternative sources for products that have gone out
              of stock.</div>
            <div class="antdiy_content_line_text_list"><em></em>Connect a new source to your existing products.</div>
            <div class="antdiy_content_line_text_list"><em></em>Merge different suppliers' products into one Shopify
              product.</div>
          </div>
          <div class="antdiy_content_line_img4 antdiy_content_line_img">
            <img class="img_bottom img_bottom4" src="/static/imgs/antdiy_4_bottom.png">
            <ImgScale class="img_top_4" url="/static/imgs/antdiy_4_top.png" type="circle" v-if="!isMobileDiy">
            </ImgScale>
            <img class="img_top_4" src="/static/imgs/antdiy_4_top.png" v-else>
          </div>
        </div>
        <div class="antdiy_content_line antdiy_content_line2">
          <div class="antdiy_content_line_img5 antdiy_content_line_img">
            <img class="img_bottom img_bottom5" src="/static/imgs/antdiy_5_bottom.png">
            <ImgScale class="img_top_5" url="/static/imgs/antdiy_5_top.png" type="circle" v-if="!isMobileDiy">
            </ImgScale>
            <img class="img_top_5" src="/static/imgs/antdiy_5_top.png" v-else>
          </div>
          <div class="antdiy_content_line_text">
            <div class="title_icon antdiy_content_line_text_symbol"></div>
            <div class="antdiy_content_line_text_title">Automatic Pricing Rules</div>
            <div class="antdiy_content_line_text_subtitle">Pre-set perfect pricing rules</div>
            <div class="antdiy_content_line_text_content">Don't know how to price the product? Our preset pricing rules
              can solve your worries. You can apply it to all imported products and automatically set your product price
              when you publish them. Welcome to use it!</div>
          </div>
        </div>
        <div class="antdiy_content_line">
          <div class="antdiy_content_line_text">
            <div class="title_icon antdiy_content_line_text_symbol"></div>
            <div class="antdiy_content_line_text_title">lnventory & Price Auto-Updates</div>
            <div class="antdiy_content_line_text_subtitle">Say goodbye to the endless spreadsheets</div>
            <div class="antdiy_content_line_text_content">When the inventory or price of AliExpress products changes,
              the data will be updated automatically in-app and notify you.</div>
          </div>
          <div class="antdiy_content_line_img6 antdiy_content_line_img">
            <img class="img_bottom img_bottom6" src="/static/imgs/antdiy_6_bottom.png">
            <ImgScale class="img_top_6" url="/static/imgs/antdiy_6_top.png" type="circle" v-if="!isMobileDiy">
            </ImgScale>
            <img class="img_top_6" src="/static/imgs/antdiy_6_top.png" v-else>
          </div>
        </div>
      </div>
      <div class="antdiy_content_bg antdiy_content_bg1"></div>
      <div class="antdiy_content_bg antdiy_content_bg2"></div>
      <div class="antdiy_content_bg antdiy_content_bg3"></div>
      <div class="antdiy_content_bg antdiy_content_bg4"></div>
      <div class="antdiy_content_bg antdiy_content_bg5"></div>
    </div>
    <div class="ant_faqs">
      <div class="ant_faqs_box">
        <div class="ant_faqs_title">
          <div class="title_icon"></div>FREQUENTLY ASKED QUESTIONS
        </div>
        <div class="ant_faqs_line">
          <img src="../assets/antdiy_faqs_1.svg">
          <div>
            <div class="ant_faqs_line_title">What e-commerce platforms does ANTDIY support?</div>
            <div class="ant_faqs_line_text">Currently we integrate with Shopify, WooCommerce, BigCommerce.</div>
          </div>
        </div>
        <div class="ant_faqs_line">
          <img src="../assets/antdiy_faqs_2.svg">
          <div>
            <div class="ant_faqs_line_title">Will ANTDIY work for my country?</div>
            <div class="ant_faqs_line_text">Yes! Since suppliers ship the items directly to your customers, dropshipping
              is borderless and can be done from anywhere in the world.</div>
          </div>
        </div>
        <div class="ant_faqs_line">
          <img src="../assets/antdiy_faqs_3.svg">
          <div>
            <div class="ant_faqs_line_title">What supply platforms do we support?</div>
            <div class="ant_faqs_line_text">Currently we are cooperating with AliExpress. In the future, we will also
              cooperate with Alibaba,1688, Taobao...</div>
          </div>
        </div>
        <div class="ant_faqs_line">
          <img src="../assets/antdiy_faqs_4.svg">
          <div>
            <div class="ant_faqs_line_title">Does ANTDIY charge?</div>
            <div class="ant_faqs_line_text">No, our products and services are completely free, there are no hidden
              charges or taxes.</div>
          </div>
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from './common/header.vue'
import Footer from './common/footer.vue'
import TopHP from './common/topHP.vue'
import ImgScale from './common/imgScale.vue'

export default {
  name: 'Antdiy',
  components: {
    Header,
    Footer,
    TopHP,
    ImgScale
  },
  data () {
    return {
      frontList: [{
        msg: 'We are the official dropshipping partner of AliExpress, our dropshipping e-commerce plugins are directly connected to the AliExpress platform.'
      }, {
        msg: 'We provide you with a one-stop solution to purchase cross-border products as simply and reliably as they do from local quality suppliers.'
      }, {
        msg: 'You can easily high-margin profitable products and save your time to focus on business growth.'
      }],
      isMobileDiy: false,
    }
  },
  created () {
    if (document.body.offsetWidth > 767) {
      this.isMobileDiy = false
    } else {
      this.isMobileDiy = true
    }
  }
}
</script>

<style scoped>
.antdiy_content {
  background: #f6f7fa;
  position: relative;
  overflow: hidden;
}
.antdiy_content_box {
  width: 1200px;
  padding: 120px 0 20px;
  margin: 0 auto;
  position: relative;
  z-index: 1;
}
.antdiy_content_line {
  display: flex;
  justify-content: space-between;
  margin-bottom: 148px;
}
.antdiy_content_line_text {
  width: 580px;
}
.antdiy_content_line_text_symbol {
  margin: 82px 0 25px;
}
.antdiy_content_line_text_title {
  height: 40px;
  font-size: 32px;
  font-family: Helvetica-Bold, Helvetica;
  font-weight: bold;
  color: #222536;
  line-height: 40px;
  margin-bottom: 25px;
}
.antdiy_content_line_text_subtitle {
  height: 28px;
  font-size: 24px;
  font-family: Helvetica-Bold, Helvetica;
  font-weight: bold;
  color: #fc5322;
  line-height: 28px;
  margin-bottom: 20px;
}
.antdiy_content_line_text_content {
  width: 636px;
  font-size: 20px;
  font-family: Helvetica;
  color: #222536;
  line-height: 30px;
}
.antdiy_content_line_text_list {
  width: 700px;
  height: 26px;
  font-size: 22px;
  font-family: Helvetica;
  color: #222536;
  line-height: 26px;
  display: flex;
  align-items: center;
}
.antdiy_content_line_text_list em {
  display: inline-block;
  width: 8px;
  height: 4px;
  background: #fc5421;
  border-radius: 2px;
  margin-right: 8px;
  flex: 0 0 auto;
}
.antdiy_content_line_text_list + .antdiy_content_line_text_list {
  margin-top: 20px;
}
.antdiy_content_line_img {
  background: rgba(252, 83, 34, 0.12);
  box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.1);
  border-radius: 20px;
  padding: 12px 15px;
  position: relative;
}
.img_bottom {
  width: 453px;
  height: 328px;
}
.img_top_1 {
  position: absolute;
  width: 374px;
  top: 259px;
  left: 162px;
}
.img_top_2 {
  position: absolute;
  width: 341px;
  top: 172px;
  left: -69px;
}
.img_top_3 {
  position: absolute;
  width: 341px;
  top: 196px;
  left: 199px;
}
.img_top_4 {
  position: absolute;
  width: 341px;
  top: 198px;
  left: -61px;
}
.img_top_5 {
  position: absolute;
  width: 341px;
  top: 190px;
  left: 184px;
}
.img_top_6 {
  position: absolute;
  width: 341px;
  top: 198px;
  left: -84px;
}

.antdiy_content_bg {
  position: absolute;
  width: 2000px;
  height: 583px;
  border-radius: 292px;
  opacity: 0.79;
  border: 120px solid #ffffff;
}
.antdiy_content_bg1 {
  top: 285px;
  left: 1128px;
}
.antdiy_content_bg2 {
  top: 851px;
  left: -1575px;
}
.antdiy_content_bg3 {
  top: 1360px;
  left: 1128px;
}
.antdiy_content_bg4 {
  top: 1885px;
  left: -1575px;
}
.antdiy_content_bg5 {
  top: 2368px;
  left: 1128px;
}
.ant_faqs {
  background: #ffffff;
}
.ant_faqs_box {
  width: 1200px;
  margin: 0 auto;
}
.ant_faqs_title {
  height: 120px;
  font-size: 32px;
  font-family: Helvetica-Bold, Helvetica;
  font-weight: bold;
  color: #222536;
  line-height: 40px;
  text-align: center;
}
.ant_faqs_title > div {
  margin: 80px auto 27px;
}
.ant_faqs_line {
  width: 1200px;
  display: flex;
}
.ant_faqs_line > img {
  margin-right: 15px;
  align-self: start;
}
.ant_faqs_line_title {
  font-size: 24px;
  font-family: Helvetica-Bold, Helvetica;
  font-weight: bold;
  color: #fc5322;
  line-height: 29px;
  margin-bottom: 15px;
}
.ant_faqs_line_text {
  font-size: 22px;
  font-family: Helvetica;
  color: #222536;
  line-height: 28px;
  margin-bottom: 40px;
}
.ant_faqs_line:nth-child(5) {
  padding-bottom: 80px;
}

@media (max-width: 767px) {
  .antdiy_content_bg {
    display: none;
  }
  .antdiy_content {
    background: #f6f7fa;
    position: relative;
    overflow: hidden;
    width: 100%;
    padding: 0 0.48rem 0.7rem;
  }
  .antdiy_content_box {
    width: 100%;
    padding: 0;
    margin: 0 auto;
    /* position: relative; */
    z-index: 1;
  }
  .antdiy_content_line {
    flex-direction: column;
    height: auto;
    margin-bottom: 0.75rem;
  }
  .antdiy_content_line_text {
    width: 100%;
  }
  .antdiy_content_line_text_symbol {
    margin: 0.8rem 0 0.31rem;
  }
  .antdiy_content_line_text_title {
    height: auto;
    font-size: 0.3rem;
    font-family: Helvetica-Bold, Helvetica;
    font-weight: bold;
    color: #222536;
    line-height: 0.42rem;
    margin-bottom: 0.15rem;
  }
  .antdiy_content_line_text_subtitle {
    height: auto;
    font-size: 0.28rem;
    font-family: Helvetica-Bold, Helvetica;
    font-weight: bold;
    color: #fc5322;
    line-height: 0.34rem;
    margin-bottom: 0.2rem;
  }
  .antdiy_content_line_text_content {
    width: 100%;
    font-size: 0.24rem;
    font-family: Helvetica;
    color: #222536;
    line-height: 0.32rem;
  }
  .antdiy_content_line_text_list {
    width: 100%;
    height: auto;
    font-size: 0.24rem;
    font-family: Helvetica;
    color: #222536;
    line-height: 0.29rem;
    display: flex;
    align-items: flex-start;
  }
  .antdiy_content_line_text_list em {
    display: inline-block;
    width: 0.1rem;
    height: 0.04rem;
    background: #fc5421;
    border-radius: 0.02rem;
    margin-right: 0.08rem;
    margin-top: 0.1rem;
    flex: 0 0 auto;
  }
  .antdiy_content_line_text_list + .antdiy_content_line_text_list {
    margin-top: 0.15rem;
  }
  .antdiy_content_line_img {
    background: rgba(252, 83, 34, 0.12);
    box-shadow: 0 0.02rem 0.06rem 0 rgba(0, 0, 0, 0.1);
    border-radius: 0.2rem;
    padding: 0.14rem 0.18rem;
    position: relative;
    margin-top: 0.5rem;
  }
  .img_bottom {
    width: 100%;
    height: 100%;
  }
  .antdiy_content_line_img1 {
    width: 91.28%;
    /* width: 5.97rem; */
    order: 1;
  }
  .antdiy_content_line_img2 {
    width: 88.69%;
    /* width: 5.8rem; */
    align-self: flex-end;
  }
  .antdiy_content_line_img3 {
    width: 90.83%;
    /* width: 5.94rem; */
    order: 1;
  }
  .antdiy_content_line_img4 {
    width: 90.21%;
    /* width: 5.9rem; */
    align-self: flex-end;
  }
  .antdiy_content_line_img5 {
    width: 90.83%;
    /* width: 5.94rem; */
    order: 1;
  }
  .antdiy_content_line_img6 {
    width: 88.84%;
    /* width: 5.81rem; */
    align-self: flex-end;
  }

  .img_top_1 {
    position: absolute;
    width: 76.88%;
    top: 73.85%;
    left: 34%;
    /* width: 4.59rem; 
    height: 1.91rem;
    top: 3.22rem;
    left: 2.03rem; */
  }
  .img_top_2 {
    position: absolute;
    width: 70%;
    top: 48.94%;
    left: -14.14%;
    /* width: 4.06rem;
    height: 2.83rem;
    top: 2.07rem;
    left: -0.82rem; */
  }
  .img_top_3 {
    position: absolute;
    width: 69.87%;
    top: 55.89%;
    left: 41.58%;
    /* width: 4.15rem;
    height: 2.58rem;
    top: 2.42rem;
    left: 2.47rem; */
  }
  .img_top_4 {
    position: absolute;
    width: 69.83%;
    top: 56.64%;
    left: -12.2%;
    /* width: 4.12rem;
    height: 2.41rem;
    top: 2.43rem;
    left: -0.72rem; */
  }
  .img_top_5 {
    position: absolute;
    width: 70.03%;
    top: 57.51%;
    left: 41.41%;
    /* width: 4.16rem;
    height: 2.45rem;
    top: 2.49rem;
    left: 2.46rem; */
  }
  .img_top_6 {
    position: absolute;
    width: 70.05%;
    top: 59.81%;
    left: -13.94%;
    /* width: 4.07rem;
    height: 2.29rem;
    top: 2.53rem;
    left: -0.81rem; */
  }

  .antdiy_content_bg {
    position: absolute;
    width: 2000px;
    height: 583px;
    border-radius: 292px;
    opacity: 0.79;
    border: 120px solid #ffffff;
  }

  .ant_faqs {
    background: #ffffff;
  }
  .ant_faqs_box {
    width: 100%;
    margin: 0 auto;
    padding: 0 0.48rem;
    display: flex;
    align-items: center;
    flex-direction: column;
  }
  .ant_faqs_title {
    width: 4.78rem;
    height: 1.11rem;
    font-size: 0.48rem;
    font-family: Helvetica-Bold, Helvetica;
    font-weight: bold;
    color: #222536;
    line-height: 0.55rem;
    text-align: center;
  }
  .ant_faqs_title {
    margin: 0.7rem 0 0.4rem;
  }
  .ant_faqs_title > .title_icon {
    display: none;
  }
  .ant_faqs_line {
    width: 100%;
  }
  .ant_faqs_line > img {
    width: 0.28rem;
    margin: 0.06rem 0.15rem 0 0;
    align-self: start;
  }
  .ant_faqs_line_title {
    font-size: 0.3rem;
    font-family: Helvetica-Bold, Helvetica;
    font-weight: bold;
    color: #fc5322;
    line-height: 0.36rem;
    margin-bottom: 0.15rem;
  }
  .ant_faqs_line_text {
    font-size: 0.24rem;
    font-family: Helvetica;
    color: #222536;
    line-height: 0.3rem;
    margin-bottom: 0.5rem;
  }
  .ant_faqs_line:nth-child(5) {
    padding-bottom: 0.7rem;
  }
}
</style>
<style>
.top_bg_p_diy {
  width: 1243px;
  height: 583px;
  border-radius: 292px;
  opacity: 0.55;
  border: 120px solid #f6f7fa;
  position: absolute;
  top: 52px;
  left: -836px;
}
.top_left_content_diy {
  font-size: 16px;
  font-family: Helvetica;
  color: #8d919b;
  line-height: 24px;
  margin-bottom: 14px;
  color: #32404d;
  display: flex;
  align-items: flex-start;
}
.top_left_content_diy > em {
  margin-top: 5px;
}
.top_left_symbol_diy {
  margin: 48px 0 21px !important;
}
@media (max-width: 767px) {
  .top_bg_p_diy {
    display: none;
  }
  .top_left_content_diy {
    font-size: 0.24rem;
    font-family: Helvetica;
    color: #8d919b;
    line-height: 0.3rem;
    margin: 0.3rem 0 0;
    color: #222536;
    display: flex;
    align-items: flex-start;
  }
  .top_left_content_diy > em {
    margin: 0.08rem 0.17rem 0 0 !important;
  }
  .top_left_content_diy:nth-child(3) {
    margin-bottom: 0.4rem;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/antDiy.vue